import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import toast from './utils/toast'
import './assets/main.css'

const app = createApp(App)
app.use(router)
// 注册全局消息提示（所有组件内的 this.$message.success/error/warning/info 均生效）
app.config.globalProperties.$message = toast
app.mount('#app')
